import { useMutation, useQueryClient } from "@tanstack/react-query";
import { privateAxios } from "../axios";
import {
	CreatePricingDetailsInput,
	PricingDetails,
	UpdatePricingDetailsInput,
} from "@dune/types";

export const pricingDetailsKeys = {
	all: ["pricing-details"] as const,
	detail: (id: number | string) => [...pricingDetailsKeys.all, id] as const,
};

const createPricingDetails = async (
	input: CreatePricingDetailsInput,
): Promise<PricingDetails> => {
	const { data } = await privateAxios.post<PricingDetails>(
		"/pricing-details",
		input,
	);
	return data;
};

const updatePricingDetails = async (
	input: UpdatePricingDetailsInput,
): Promise<PricingDetails> => {
	const { id, ...rest } = input;
	const { data } = await privateAxios.put<PricingDetails>(
		`/pricing-details/${id}`,
		rest,
	);
	return data;
};

export const useCreatePricingDetailsMutation = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: createPricingDetails,
		onSuccess: (created) => {
			queryClient.invalidateQueries({ queryKey: pricingDetailsKeys.all });
			queryClient.invalidateQueries({
				queryKey: pricingDetailsKeys.detail(created.id),
			});
		},
	});
};

export const useUpdatePricingDetailsMutation = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: updatePricingDetails,
		onSuccess: (updated) => {
			queryClient.invalidateQueries({ queryKey: pricingDetailsKeys.all });
			queryClient.invalidateQueries({
				queryKey: pricingDetailsKeys.detail(updated.id),
			});
		},
	});
};
